import axios from "../utils/axiosConfig";

const profileService = {
    getById: async (id) => {
        try {
            const response = await axios.get(`/profiles/${id}`);
            return response.data;
        } catch (error) {
            console.warn("API Error, returning mock data", error);
        }
    },
    
    update: async (id, data) => {
        return axios.put(`/profiles/${id}`, data);
    },

    updateAvatar: async (id, data) => {
        return axios.put(`/profiles/${id}/avatar`, data);
    },

    updatePassword: async (id, data) => {
        return axios.put(`/profiles/${id}/password`, data);
    },
};

export default profileService;